/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6ce7c4acebb1eb837d79bd4569e8970eb722bb5d";
